import React, {useMemo} from 'react'
import Text from '../../../components/text/Text'
import {Link, useLocation, useNavigate} from 'react-router-dom'

interface ISidebarItem {
    name: string
    path: string[]
    tag: string
}

interface IProps {
    className?: string
    item?: ISidebarItem
}

const SidebarItem: React.FC<IProps> = ({className, item}) => {
    const location = useLocation()
    const navigate = useNavigate()
    const renderActiveText = useMemo(() => {
        if (item.path.find(path => path === location.pathname)) {
            return 'text-white bg-primary'
        } else {
            return 'text-font03 hover:text-font01 hover:bg-tag_green_light'
        }
    }, [item, location])

    return (
        <div className={`pl-[10px]`}>
            <Link
                to={item?.path[0]}
                className={`px-[10px] block text-ti2 py-[5px] rounded-[5px] cursor-pointer ${renderActiveText}`}>
                {item?.name}
            </Link>
        </div>
    )
}

export default SidebarItem
